import { connect } from 'react-redux';

import { ProductLineName } from '@/components/modals/SubmitOrder/types';
import { selectProposalItems } from '@/store/reducers/dictionaries/selectors';
import { selectNewOpportunity } from '@/store/reducers/opportunities/selectors';
import {
  selectDesignToOrderProducts,
  selectProductLineName,
} from '@/store/reducers/products/selectors';
import { AppState } from '@/types';

import { EquipmentDetails as Component } from './EquipmentDetails';

const mapStateToProps = (state: AppState) => ({
  allPriceBookEntries: selectDesignToOrderProducts(state),
  opportunity: selectNewOpportunity(state),
  proposalItems: selectProposalItems(state),
  productLineName: selectProductLineName(state) as ProductLineName,
});

export const EquipmentDetails = connect(mapStateToProps)(Component);
